module.exports = __webpack_public_path__ + "static/media/ft.81fb5dac.png";